import qs from 'qs'

const SLOTS_FAVICON = 'static/images/favicon_slots.png'
const SLOTS_TOUCH_ICON = 'static/images/favicon192_slots.png'

function getLinkElement (selector, rel) {
  let link = document.querySelector(selector)

  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', rel)
    document.head.appendChild(link)
  }

  return link
}

export function isSlotsRedirect () {
  const redirectTo = qs.parse(window.location.search, { ignoreQueryPrefix: true }).r
  const isFreeReelSlots = window.location.hostname.toLowerCase().includes('freereelslots')

  return !isFreeReelSlots &&
    typeof redirectTo === 'string' &&
    redirectTo.toLowerCase().includes('slots')
}

export function setSlotsFavicon () {
  const favicon = getLinkElement('link[rel~="icon"]', 'shortcut icon')
  favicon.setAttribute('type', 'image/png')
  favicon.setAttribute('href', SLOTS_FAVICON)

  const touchIcon = getLinkElement('link[rel="apple-touch-icon"]', 'apple-touch-icon')
  touchIcon.setAttribute('href', SLOTS_TOUCH_ICON)
}

export function setSlotsFaviconFromRedirect () {
  if (isSlotsRedirect()) {
    setSlotsFavicon()
  }
}



// WEBPACK FOOTER //
// ./src/utils/favicon.js